export const holdNotesFields = [
  { field: "HoldDate", order: 1, label: "Hold Date" },
  { field: "CustomerName_2", order: 2, label: "CustomerName" },
  { field: "HoldNoteText", order: 3, label: "Hold Note" },
  { field: "HoldReleaseDate", order: 4, label: "Hold Release" },
  { field: "EmployeeName_2", order: 5, label: "Entered By" },
  { field: "HoldFor", order: 6, label: "Entered For" },
  { field: "IsSold", order: 7, label: "Is Sold" },
  { field: "Feeds", order: 8, label: "Feeds" },
  { field: "JewelryHoldRestriction", order: 9, label: "Hold Restriction" },
];
